import { IconLayer, ScatterplotLayer } from '@deck.gl/layers'
import iconAtlas from './iconAtlas.json'

export const DeckGlLayers = (data, gateListings = [], handleClusterClick, handleMarkerClick) => {
    if (!data) return []
    const createIconLayer = (id, data, iconUrl, iconMappingUrl) => {
        return new IconLayer({
            id,
            data: data,
            sizeScale: 1,
            getColor: d => d?.is_online ? [0, 158, 96] : [255, 64, 61],
            getIcon: d => d?.is_online ? 'online-marker' : 'offline-marker',
            iconAtlas: iconUrl,
            iconMapping: iconMappingUrl,
            pickable: true,
            getSize: 30,
            getPosition: d => d.geometry.coordinates,
            onClick: d => {
                const obj = d.object
                handleMarkerClick(obj)
            },
            autoHighlight: true,
            billboard: true,
            parameters: {
                depthTest: false,
                blend: true
            },
            highlightColor: [0, 0, 0, 20]
        })
    }

    const createCircleLayer = (id, data) => {
        return new ScatterplotLayer({
            id,
            data,
            pickable: true,
            filled: true,
            radiusScale: 1,
            radiusUnits: 'pixels',
            getFillColor: d => {
                return d?.properties?.cluster
                    ? [117, 117, 117]
                    : d.color
            },
            getLineColor: [255, 255, 255],
            getLineWidth: 2,
            getRadius: d =>
                d?.properties?.cluster
                    ? 10
                    : 6,
            getPosition: d => d.geometry.coordinates,
            onClick: d => {
                const obj = d.object
                if (obj?.properties?.cluster) {
                    handleClusterClick(obj)
                } else {
                    handleMarkerClick(obj)
                }
            },
            autoHighlight: true,
            parameters: {
                depthTest: false
            }
        })
    }

    return [
        createIconLayer('listings', gateListings, '/media/logos/gateIcon.png', iconAtlas),
        createCircleLayer('other-listings', data)
    ]
}